import { Button, IconButton } from '@mui/material';
import { ArrowRightIcon, CrossIcon, ModalConfirm, ModalFooter, ModalHeader } from '@schooly/style';
import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { CloseAccountForm } from './CloseAccountForm';
import { CloseAccountInfo } from './CloseAccountInfo';

export interface CloseAccountModalProps {
  onClose: VoidFunction;
}

enum CloseAccountModalMode {
  Info,
  ResetPassword,
}

export const CloseAccountModal: React.FC<CloseAccountModalProps> = ({ onClose }) => {
  const [mode, setMode] = useState(CloseAccountModalMode.Info);

  const { formatMessage } = useIntl();

  const titleTextId = useMemo(() => {
    switch (mode) {
      case CloseAccountModalMode.Info:
        return 'login-YouAreAboutToRemove';
      case CloseAccountModalMode.ResetPassword:
        return 'login-PleaseEnterPassword';
      default:
        break;
    }
  }, [mode]);

  return (
    <ModalConfirm open onClose={onClose}>
      <ModalHeader active multiline title={formatMessage({ id: titleTextId })}>
        <IconButton onClick={onClose}>
          <CrossIcon />
        </IconButton>
      </ModalHeader>
      {mode === CloseAccountModalMode.Info && <CloseAccountInfo />}
      {mode === CloseAccountModalMode.ResetPassword && <CloseAccountForm />}
      {mode === CloseAccountModalMode.Info && (
        <ModalFooter active>
          <Button
            endIcon={<ArrowRightIcon />}
            onClick={() => setMode(CloseAccountModalMode.ResetPassword)}
          >
            {formatMessage({ id: 'action-Continue' })}
          </Button>
        </ModalFooter>
      )}
    </ModalConfirm>
  );
};
